/**
 * Ссылка «куда ведёт работа по предписанию» (общая для виджета предписаний и
 * дела контура). Сам блок предписаний — `astra/widgets/prescriptions/PrescriptionsWidget`.
 */
import { Link } from 'react-router-dom';
import { useAnalysisContext } from '../../../analysis/context';
import { OUTSIDE_CYCLE_WORD } from './quarantineArea';
import { defineMessages } from '../../../i18n/define';
import { useT } from '../../../i18n/hooks';

const m = defineMessages({
  linkWork: { id: 'quarantine.prescriptions.link.work', defaultMessage: 'работа в агроцикле {name}', description: 'Ссылка на работу по предписанию в агроцикле; {name} — название агроцикла («Хлопок-2026»)' },
  linkCycle: { id: 'quarantine.prescriptions.link.cycle', defaultMessage: 'в агроцикле {name}', description: 'Ссылка на агроцикл, где лежит работа по предписанию; {name} — название агроцикла' },
  outsideCycle: { id: 'quarantine.prescriptions.outsideCycle', defaultMessage: 'вне агроцикла', description: 'Пометка у работы по предписанию, которая вне агроцикла и причина не названа; строчными' },
});

/** Куда ведёт работа: агроцикл, в приёмнике которого она лежит, или причина «вне агроцикла». */
export function WorkCycleLink({
  work,
}: {
  work: { cycle_key?: string | null; cycle_name?: string | null; campaign_id?: number | null; outside_cycle_reason?: string | null };
}) {
  const t = useT();
  const { linkSearch } = useAnalysisContext();
  // Ссылка — на карточку работы-предписания в цикле (кампания-приёмник
  // открывается по самой кампании, Г1 №948); без кампании — на агроцикл (К9).
  if (work.cycle_key && work.campaign_id) {
    return <Link to={`/cycles/${work.cycle_key}/works/${work.campaign_id}${linkSearch()}`}>{t(m.linkWork, { name: work.cycle_name ?? work.cycle_key })}</Link>;
  }
  if (work.cycle_key) {
    return <Link to={`/cycles/${work.cycle_key}${linkSearch()}`}>{t(m.linkCycle, { name: work.cycle_name ?? work.cycle_key })}</Link>;
  }
  return (
    <span className="muted">
      {work.outside_cycle_reason
        ? OUTSIDE_CYCLE_WORD[work.outside_cycle_reason] ?? work.outside_cycle_reason
        : t(m.outsideCycle)}
    </span>
  );
}
